import { render } from "./cookies-policy.vue?vue&type=template&id=0a098314"
import script from "./cookies-policy.vue?vue&type=script&lang=js"
export * from "./cookies-policy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__